import React, { Component } from "react";
import { connect } from "react-redux";
import { customerActions } from "redux/actions/customer-action";
import SimpleReactValidator from "simple-react-validator";
import Address from "../../ThemeComponents/Address";
import { objectsConstants as OC } from "redux/constant/objects-constant";
import User from "../../ThemeComponents/User";
import Contact from "../../ThemeComponents/Contact";
import CompanyName from "./CompanyName";
import { withRouter } from "react-router-dom";
import { listActions } from "../../../redux/actions/list-actions";

import { helperFunctions as HF } from '../../../helper/helperFunctions';

// add new tag type form component and files //
import ListForm from '../Lists/ListForm';

var Modal = require('react-bootstrap-modal');

class AddCustomer extends Component {
    constructor(props) {
        super(props);
        this.validatorCustomer = new SimpleReactValidator();
        this.state = {
            user: OC.user,
            states: [],
            initialState: {
                contact: {
                    first_name: "",
                    last_name: "",
                    email: "",
                    type_id: "",
                    customer_id:
                        this.props.match.params.id !== ""
                            ? this.props.match.params.id
                            : ""
                },
                user: {
                    user_name: "",
                    password: "",
                    password_confirmation: ""
                },
                address: {
                    contact_name: "",
                    line1: "",
                    country_id: "",
                    city: "",
                    region_id: "",
                    zip_post_code: ""
                }
            },
            submitted: false,
            formType: "add",
            isFetched: this.props.match.params.id !== "" ? false : true,
            edit_customer_id: this.props.match.params.id || "",

            tagTypeAddModal: false
        };
        this.onChange = this.onChange.bind(this);
        this.handleCustomerSubmit = this.handleCustomerSubmit.bind(this);
        this.handleChangeDropdown = this.handleChangeDropdown.bind(this);
        this.getChildState = this.getChildState.bind(this);
        this.props.getListCall('country', "", "", "", "", "country", false);
    }

    onChange(e) {
        this.setState({
            user: {
                ...this.state.user,
                [e.target.name]: e.target.value
            }
        });
    }
    getState = state => {
        this.setState(prevState => ({
            user: {
                ...prevState.user,
                ...state
            }
        }));
    };
    getStateContact = state => {
        this.setState(prevState => ({
            user: {
                ...prevState.user,
                customer: {
                    title: prevState.user.customer.title,
                    ...state
                }
            }
        }));
    };
    getStateUser = state => {
        this.setState(prevState => ({
            user: {
                ...prevState.user,
                ...state.user
            }
        }));
    };
    getStateCompany = state => {
        this.setState(prevState => ({
            user: {
                ...prevState.user,
                customer: {
                    ...prevState.user.customer,
                    ...state
                }
            }
        }));
    };

    handleCustomerSubmit(e) {
        e.preventDefault();

        if (this.validatorCustomer.allValid()) {
            this.setState({
                submitted: true
            });
            const { user } = this.state;
            let obj = {
                contact: user.customer.contact,
                customer: { title: user.customer.title },
                user: {
                    user_name: user.user_name,
                    password: user.password,
                    password_confirmation: user.password_confirmation,
                },
                address: user.address
            }
            this.props.storeCustomerCall(obj);
        } else {
            this.setState({ submitted: false });
            this.validatorCustomer.showMessages();
            this.forceUpdate();
        }
    }

    handleChangeDropdown(selectedOption, info) {
        if (info.name === "state") {
            this.setState({
                customer: {
                    ...this.state.customer,
                    stateId: selectedOption.value
                }
            });
        }
        if (info.name === "country") {
            this.setState(
                {
                    customer: {
                        ...this.state.customer,
                        countryId: selectedOption.value
                    }
                },
                () => {
                    let updatedStates = [];
                    this.props.states.forEach(state => {
                        if (state.countryId === this.state.customer.countryId)
                            updatedStates.push(state);
                    });
                    this.setState({
                        ...this.state.customer,
                        states: updatedStates
                    });
                }
            );
        }
    }

    getChildState(childData) {
        this.setState(
            {
                addressObj: childData
            }
        );
    }

    getUserProps = () => {
        if (this.state.formType === "edit") {
            return this.state.user.customer;
        } else {
            return this.state.initialState;
        }
    };


    // functions to add new state //
    handleDropDownAddNewSubmit = (listData, formType) => {
        let list;
        if (this.state.addNewModelType === 'region') {
            list = {
                title: listData.title,
                list_type_id: this.state.list_type_id,
                list_type: this.state.addNewModelType,
                parent_id: this.state.user.address.country_id,
                parent: this.state.user.address.country,
                component_name: this.state.addNewModelDisplayTitle
            };
        }
        else {
            list = {
                title: listData.title,
                list_type_id: this.state.list_type_id,
                list_type: this.state.addNewModelType,
                component_name: this.state.addNewModelDisplayTitle
            };
        }

        this.props.storeTagTypeCall(list).then(
            response => {
                if (this.state.addNewModelType === 'region') {
                    this.props.refreshRegionsListCall(this.state.user.address.country_id);
                }
                this.props.getListCall(this.state.addNewModelType, "", "", "", "", this.state.addNewModelType, false);
                this.setState({
                    ...this.state,
                    tagTypeAddModal: false,
                });
            },
            error => {
                return error;
            }
        );
    }
    returnTagTypeState = state => {
        if (state.tagTypeAddModal !== undefined) {
            this.setState(prevState => ({
                ...prevState.tagTypeAddModal,
                ...state
            }));
        }
        else {
            this.setState(prevState => ({
                user: {
                    ...prevState.user,
                    ...state
                }
            }));
        }
    };
    openAddNewTagForm = (modelType, displayTitle, listTypeId) => {
        this.returnTagTypeState({
            tagTypeAddModal: true,
            addNewModelType: modelType,
            addNewModelDisplayTitle: displayTitle,
            list_type_id: listTypeId
        });
    };

    render() {
        // const { user_name, password, password_confirmation } = this.state.user;
        // const {
        //     email,
        //     first_name,
        //     last_name
        // } = this.state.user.customer.contact;

        return (
            <React.Fragment><div className="container">
                <h3 style={{ textAlign: "center", fontWeight: "500" }}>
                    {!this.state.edit_customer_id && (
                        <span>Add New Customer</span>
                    )}
                    {this.state.edit_customer_id && <span>Edit Customer</span>}
                </h3>
                <form onSubmit={this.handleCustomerSubmit}>
                    <div className="row">
                        <div className="col-md-8 col-md-offset-2">
                            <React.Fragment>
                                <div className="flexElem addCustomer">
                                    <Contact
                                        contactObject={this.state.user.customer}
                                        contactProp={this.state.user.customer}
                                        requiredField={{
                                            first_name: "required",
                                            last_name: "required",
                                            email: "required"
                                        }}
                                        shippingAddress={false}
                                        htmlElement={"contact"}
                                        returnState={this.getStateContact}
                                        validatorInstance={
                                            this.validatorCustomer
                                        }
                                    />
                                    <User
                                        requiredField={{
                                            user_name: "required",
                                            password: "required",
                                            password_confirmation: "required"
                                        }}
                                        htmlElement={"user"}
                                        returnState={this.getStateUser}
                                        validatorInstance={
                                            this.validatorCustomer
                                        }
                                        contactProp={this.getUserProps()}
                                    />
                                    <CompanyName
                                        requiredField={{
                                            title: "required"
                                        }}
                                        htmlElement={"company"}
                                        returnState={this.getStateCompany}
                                        validatorInstance={
                                            this.validatorCustomer
                                        }
                                    />
                                </div>

                                <Address
                                    addressObject={
                                        this.state.initialState.address
                                    }
                                    htmlElement={"customer"}
                                    shippingAddress={false}
                                    options={{
                                        countries: this.props.countries
                                    }}
                                    requiredField={{
                                        contact_name: "required",
                                        line1: "required",
                                        country_id: "required",
                                        city: "required",
                                        region_id: "required",
                                        zip_post_code: ""
                                            ? ["integer", "required"]
                                            : ["integer"],
                                        phone: "required",
                                        email: "required"
                                    }}
                                    countries={this.props.country}
                                    getChildState={this.getChildState}
                                    returnState={this.getState}
                                    validatorInstance={this.validatorCustomer}

                                    openAddNewTagForm={this.openAddNewTagForm}
                                    showTagTypeAddModal={this.state.showTagTypeAddModal}
                                    refreshRegionsTime={this.state.refreshRegionsTime}

                                />
                            </React.Fragment>
                        </div>

                        <div className="col-md-12 text-center mt-xlg">
                            <input
                                type="submit"
                                value="Add Customer"
                                className="customBtn btnBlue"
                            />
                        </div>
                    </div>
                </form>
            </div>

                {/*Add Modal Start*/}
                {this.props.TagLayoutData !== null &&
                    <Modal show={this.state.tagTypeAddModal} onHide={HF.closeModal.bind(this, "tagTypeAddModal")} aria-labelledby="ModalHeader">
                        <Modal.Header closeButton>
                            <Modal.Title id='ModalHeader' className="headerTitle text-capitalize">Add {this.state.addNewModelDisplayTitle}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="row">
                                <div className="col-md-8 col-md-offset-2">
                                    <ListForm
                                        closeModel={HF.closeModal.bind(this, "tagTypeAddModal")}
                                        formTypePro="add"
                                        listPro={{ list: OC.list }}
                                        handleListSubmit={this.handleDropDownAddNewSubmit}
                                        name={this.props.title}
                                        componentPro={'List'}
                                        parent_id={this.state.tagTypeParentId}
                                    />
                                </div>
                            </div>
                        </Modal.Body>
                    </Modal>
                }
                {/*Add Modal End*/}
            </React.Fragment>
        );
    }
}
const mapDispatchToProps = dispatch => {
    return {
        storeCustomerCall: data => {
            dispatch(customerActions.storeCustomer(data));
        },
        storeTagTypeCall: (listData) => { return dispatch(listActions.storeList(listData)) },
        refreshRegionsListCall: (id) => { return dispatch(listActions.getListItem(id)) },
        getListCall: (
            id,
            page,
            filter,
            sort,
            pageSize,
            component_name,
            pagination
        ) => {
            dispatch(
                listActions.getList(
                    id,
                    page,
                    filter,
                    sort,
                    pageSize,
                    component_name,
                    pagination
                )
            );
        }
    };
};

function mapStateToProps(state) {
    const { country } = state.listReducer;
    return {
        country
    };
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(AddCustomer)
);



// WEBPACK FOOTER //
// ./src/components/Admin/Customers/AddCustomer.jsx